module.exports = __webpack_public_path__ + "static/media/27OCHA11.b3b90904.jpg";